import React from "react";
import { Image } from 'semantic-ui-react'

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top" style={{paddingTop: "5px"}}>
            <Image src="img/android-chrome-192x192.png" avatar />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
                Selskaber
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Julefrokost
              </a>
            </li>
            <li>
              <a href="#sommerfest" className="page-scroll">
                Sommerfest
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                Galleri
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                Om
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Kontakt
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
